/**
 * Custom Apparel Design Functionality
 * Handles dynamic URL generation based on metafield and variant selection
 */

(function() {
  'use strict';

  class CustomApparelHandler {
    constructor(formElement) {
      this.form = formElement;
      this.designButton = this.form.querySelector('[data-custom-apparel-button]');
      this.metafieldValue = this.form.dataset.customApparelMetafield;
      this.baseUrl = 'https://www.bulkprintedtees.com/pages/create-your-own';
      
      if (!this.designButton || !this.metafieldValue) {
        return;
      }
      
      this.init();
    }
    
    init() {
      // Listen for variant changes
      this.form.addEventListener('change', (e) => {
        if (e.target.name === 'id' || e.target.closest('[data-swatch-item]')) {
          this.updateDesignUrl();
        }
      });
      
      // Set initial URL
      this.updateDesignUrl();
    }
    
    getSelectedOptionValue(matchers) {
      const variantSelect = this.form.querySelector('select[name="id"]');
      if (!variantSelect) return '';

      const selectedVariantId = variantSelect.value;
      if (!selectedVariantId) return '';

      const variantContainer = this.form.closest('[data-callBackVariant]');
      const variantsJson = variantContainer?.querySelector('.pr_variants_json');
      const optionsJson = variantContainer?.querySelector('.pr_options_json');

      if (!variantsJson || !optionsJson) return '';

      try {
        const variants = JSON.parse(variantsJson.textContent);
        const options = JSON.parse(optionsJson.textContent);
        const selectedVariant = variants.find(v => v.id == selectedVariantId);

        if (!selectedVariant) return '';

        const optionIndex = options.findIndex(option => {
          const optionName = option.name.toLowerCase();
          return matchers.some(matcher => optionName.includes(matcher));
        });

        if (optionIndex === -1) return '';

        const value = selectedVariant[`option${optionIndex + 1}`];
        return value || '';
      } catch (error) {
        console.error('Error parsing variant data:', error);
        return '';
      }
    }
    
    updateDesignUrl() {
      const rawColor = this.getSelectedOptionValue(['color', 'colour', 'couleur']);
      const rawSize = this.getSelectedOptionValue(['size']);
      const colorVariant = rawColor ? rawColor.toLowerCase().replace(/\s+/g, '%20') : '';
      const sizeVariant = rawSize ? rawSize.toLowerCase().replace(/-/g, '').trim() : '';
      
      // Build URL with parameters
      const url = new URL(this.baseUrl);
      url.searchParams.set('product', this.metafieldValue);
      
      if (colorVariant) {
        url.searchParams.set('color', colorVariant);
      }

      if (sizeVariant) {
        url.searchParams.set('size', sizeVariant);
      }
      
      this.designButton.href = url.toString();
    }
  }
  
  // Initialize on DOMContentLoaded
  function initCustomApparel() {
    const customApparelForms = document.querySelectorAll('[data-custom-apparel-enabled]');
    customApparelForms.forEach(form => {
      new CustomApparelHandler(form);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomApparel);
  } else {
    initCustomApparel();
  }
  
  // Re-initialize when dynamic content is loaded (for quick view, etc.)
  document.addEventListener('shopify:section:load', initCustomApparel);
  
})();
